export type ThemeFontFamilyName = 'body' | 'heading';

export const Fonts: Record<ThemeFontFamilyName, string[]> = {
  body: ['Open Sans', 'Arial', 'sans-serif'],
  heading: ['Cal Sans', 'Arial', 'sans-serif'],
};
